<script>
    import {onMount} from 'svelte';
    import {sgettext} from '../../../i18n.js';
    import {slide} from 'svelte/transition';
    import {getSetting, setSetting} from '../../../utils'
    import {PATH_PREFIX} from "../../../apiUrls"

    export let toggleColumnDisplay = () => {};
    export let displayOptions = [];
    export let persistKey = null;

    const QUALITY_QUESTION_ICON_LOCATION = `${PATH_PREFIX}/sw/static/common/images/QualityQuestion.png`;

    let collapsed = true;

    function toggleDisplayOptions() {
        collapsed = !collapsed;
    }

    function selectOption(option, select){
        const opt = displayOptions.find(o => o.id === option.id);
        opt.selected = select;
        displayOptions = [...displayOptions];
        toggleColumnDisplay(displayOptions);
        saveOptions(displayOptions);
    }

    function saveOptions(options) {
        const selected = options
            .filter(o => o.selected)
            .map(o => o.id)
        if (persistKey) {
            setSetting(persistKey, JSON.stringify(selected))
        }
    }

    function loadOptions(options) {
        if (persistKey) {
            let value = getSetting(persistKey);
            if (!value) {
                value = '["time"]';
                setSetting(persistKey, value)
            }
            const storedOptions = JSON.parse(value)
            return options.map(o => {
                if (storedOptions.includes(o.id)) {
                    o.selected = true;
                }
                return o;
            })
        }
        return options;
    }

    onMount(() => {
        displayOptions = [...loadOptions(displayOptions)];
        toggleColumnDisplay(displayOptions);

        // catch document-wide clicks and collapse the dropdown
        const listener = document.addEventListener('click', event => {
            if (!collapsed) {
                const closest = event.target.closest('.column-toggle');
                if (!closest) {
                    collapsed = true
                }
            }
        })
        return () => document.removeEventListener('click', listener);
    })

    



</script>

<style>
    .column-toggle {
        background-color: white;
        width: 250px;
        position: relative;
    }

    .label > div {
        flex: 1;

    }

    .option, .label {
        display: flex;
        align-items: center;
        padding: 5px;
    }

    .label {
        color: #abacae;
        padding: 5px 15px;
    }

    .option {
        margin-bottom: 3px;
    }

    .option > div {
        flex: 1;
    }

    .left {
        margin-right: 5px;
    }

    .options {
        position: absolute;
        padding: 5px 10px;
        width: 250px;
        background-color: white;
        z-index: 10;
    }

    .shadow {
        box-shadow: rgba(0, 0, 0, 0.18) 0px 2px 4px;
    }

    .selected {
        background-color: #ebeef0;
        color: #454545;
        text-align: left;
        font-size: 14px;
    }

    .fa5-times-circle {
        cursor: pointer;
    }
</style>

<div class="column-toggle">
    <div class="label" on:click={toggleDisplayOptions}>
        <div>{sgettext('$$DISPLAY$$')}</div>
        <i class="fas right" class:fa5-angle-down={collapsed} class:fa5-angle-up={!collapsed}/>
    </div>
    {#if !collapsed}
        <div class="options" transition:slide|local class:shadow={!collapsed}>
            {#each displayOptions as option}
                <div
                    class="option"
                    class:selected={option.selected}
                    class:badge={option.selected}
                    class:badge-pill={option.selected}
                    on:click={() => selectOption(option, true)}
                >
                    {#if !option.faIcon}
                        <img alt="sw" src={QUALITY_QUESTION_ICON_LOCATION} width="16" height="14">
                    {:else}
                        <i class="{option.faIcon.classes} left" style="{option.faIcon.style}"/>
                    {/if}
                    <div>{option.name}</div>
                    {#if option.selected}
                        <i class="fas fa5-times-circle" on:click|stopPropagation={() => selectOption(option, false)}/>
                    {/if}
                </div>
            {/each}
        </div>
    {/if}

</div>
